import { CatTextLink } from 'blocks-nextjs/blocks-react/components/TextLink';
import { CatTextPassage } from 'blocks-nextjs/blocks-react/components/TextPassage';
import { CatTooltip } from 'blocks-nextjs/blocks-react/components/Tooltip';
import { useTranslations } from 'next-intl';

const CoreDepositTooltip = () => {
  const t = useTranslations();

  return (
    <CatTooltip isInteractive>
      <CatTextLink
        size="sm"
        slot="trigger"
        data-testid="core-deposit-tooltip-trigger"
      >
        <span className="text-end cat-u-theme-typography-footnote">
          {`${t('CAT_CORE_DEPOSIT_TITLE')}:`}
        </span>
      </CatTextLink>
      <CatTextPassage size="xs">
        {t('CAT_CORE_DEPOSIT_TOOLTIP_CONTENT')}
      </CatTextPassage>
    </CatTooltip>
  );
};

export default CoreDepositTooltip;
